import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import { getClientMessages, getModalMessages } from '../../../../../constants/messages';
import LogsView from './View';

let clientMessages = getClientMessages(),
	modalMessages = getModalMessages();

const messages = {
	...clientMessages,
	...modalMessages,
};

class PDLogsModal extends React.Component {
	render() {
		const {
			props: { clientId, showModal, handleCancel, intl },
		} = this;

		return (
			<Modal
				open={showModal}
				title={intl.formatMessage({ ...messages.deactivationLog })}
				onCancel={handleCancel}
				destroyOnClose={true}
				footer={[
					<Button key="close" onClick={handleCancel}>
						{intl.formatMessage({ ...messages.close })}
					</Button>,
				]}
				width={1000}
			>
				<LogsView clientId={clientId} />
			</Modal>
		);
	}
}

PDLogsModal.propTypes = {
	intl: PropTypes.object.isRequired,
	showModal: PropTypes.bool.isRequired,
	clientId: PropTypes.number.isRequired,
	handleCancel: PropTypes.func.isRequired,
};

export default injectIntl(PDLogsModal);
